import { MOVING_IN } from "constants-lib/actionTypes"

export const setMovingIn = (movingIn) => (dispatch) => {
  dispatch({
    type: MOVING_IN,
    movingIn,
  })
}
